var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoCircleDarkPink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "#8D027D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0278 5.40027C7.31234 5.40027 7.543 5.63093 7.543 5.91547V9.9848C7.543 10.2693 7.31234 10.5 7.0278 10.5C6.74327 10.5 6.5126 10.2693 6.5126 9.9848V5.91547C6.5126 5.63093 6.74327 5.40027 7.0278 5.40027ZM7.0166 3.5C7.23314 3.5 7.4086 3.5672 7.543 3.7016C7.6774 3.836 7.7446 4.004 7.7446 4.2056C7.7446 4.4072 7.6774 4.5752 7.543 4.7096C7.4086 4.83653 7.23314 4.9 7.0166 4.9C6.80754 4.9 6.6358 4.83653 6.5014 4.7096C6.367 4.5752 6.2998 4.4072 6.2998 4.2056C6.2998 4.004 6.367 3.836 6.5014 3.7016C6.6358 3.5672 6.80754 3.5 7.0166 3.5Z",
    fill: "#8D027D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleDarkPink);
export default __webpack_public_path__ + "static/media/info_circle_dark_pink.3d5230bc09a914c5403c1b47d36b51d1.svg";
export { ForwardRef as ReactComponent };